import { render } from "./ResearchComponent.vue?vue&type=template&id=65b4324a"
import script from "./ResearchComponent.vue?vue&type=script&lang=js"
export * from "./ResearchComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\z4613\\Downloads\\461374167.github.io-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__